import { Schema, Field } from 'v4f';

/* eslint-disable new-cap */
const formSchema = Schema({
  email: Field()
    .string()
    .email()
    .required(),
  name: Field()
    .string()
    .lengthGreater(1)
    .required(),
  terms: Field()
    .boolean()
    .truthy(),
});

const validateForm = (data) => formSchema.validate(data);

export default validateForm;
